/* eslint-disable typescript-extended-rules/file-naming-convention */
import { BeneficiaryReconciliationField } from '../../../../modules/beneficiary-reconciliations/models/beneficiary-reconciliation.model';

export interface BeneficiaryReconciliationFieldMetadata {
	description: string;
	label: string;
}

export const BENEFICIARY_RECONCILIATION_FIELD_METADATA: Record<
	BeneficiaryReconciliationField,
	BeneficiaryReconciliationFieldMetadata
> = {
	ACTIVE_MISSING_IN_DB: {
		description:
			'Beneficiário está na base do cliente, mas não foi localizado na plataforma',
		label: 'Não encontrado na plataforma',
	},
	CARD_MISMATCH: {
		description:
			'Número da carteirinha está diferente entre plataforma e base do cliente',
		label: 'Divergência de carteirinha',
	},
	DUPLICATE_IN_FILE: {
		description: 'Beneficiário aparece mais de uma vez na base do cliente',
		label: 'Duplicado na base do cliente',
	},
	INACTIVE_MISSING_IN_FILE: {
		description:
			'Beneficiário está na plataforma, mas não foi localizado na base do cliente',
		label: 'Não encontrado na base do cliente',
	},
	ORGANIZATION_MISMATCH: {
		description:
			'Beneficiário está ativo na plataforma em um CNPJ diferente da base do cliente',
		label: 'Divergência de CNPJ',
	},
	PLAN_MISMATCH: {
		description: 'Plano está diferente entre plataforma e base do cliente',
		label: 'Divergência de plano',
	},
	TITULARITY_MISMATCH: {
		description:
			'Titularidade está diferente entre plataforma e base do cliente',
		label: 'Divergência de titularidade',
	},
};

export function getBeneficiaryReconciliationFieldLabel(
	field: BeneficiaryReconciliationField,
): string {
	return BENEFICIARY_RECONCILIATION_FIELD_METADATA[field]?.label ?? field;
}

export function getBeneficiaryReconciliationFieldDescription(
	field: BeneficiaryReconciliationField,
): string {
	return BENEFICIARY_RECONCILIATION_FIELD_METADATA[field]?.description ?? '';
}
